import { Step } from '@repo/common';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ButtonsGroup,
  ColorVariant,
  Container,
  PrimaryButton,
  SuccessIcon,
  Text,
  Title,
} from '@/components/verification-result/components';
import { withStep } from '@/hoc/with-step';
import { useAppContext } from '@/providers/app-provider/context';
import * as GSC from '@/styles/GlobalStyles';
import { ViewType } from '@/utils/enums';
import { resolveVerificationRedirect } from '@/utils/workflow';

export const EnrolmentPendingReview = withStep({ only: [Step.SUCCESS] })(() => {
  const { t } = useTranslation();
  const {
    state: { customerData, viewType },
  } = useAppContext();

  const returnToPage = () => {
    resolveVerificationRedirect({
      payload: { result: 'success' },
      url: customerData?.redirect?.verifiedUrl ?? '',
      viewType: viewType!,
    });
  };

  useEffect(() => {
    if (viewType !== ViewType.IFRAME) {
      return;
    }

    window.parent.postMessage(JSON.stringify({ enrolmentPending: true }), '*');
  }, [viewType]);

  return (
    <GSC.FadeInContainer>
      <Container>
        <SuccessIcon />
        <Title $colorVariant={ColorVariant.SUCCESS} id="enrolment-pending-title">
          {t('steps.enrolmentPending.title')}
        </Title>
        <Text id="enrolment-pending-subtitle">{t('steps.enrolmentPending.subtitle')}</Text>
        <ButtonsGroup>
          <PrimaryButton onClick={returnToPage}>{t('steps.enrolmentPending.returnButton')}</PrimaryButton>
        </ButtonsGroup>
      </Container>
    </GSC.FadeInContainer>
  );
});
